/**
 * Space-scoped identity helpers (v0.11 — plan 2026-07-31-space-scoped-naming).
 *
 * A declaration's identity space is the space of its LANDED root ancestor
 * (plan D1a): for an `in Api …` placement, the target's space; for
 * body-nested declarations, the enclosing root's. The declaring FILE's
 * space is used only as the referrer space when resolving that
 * declaration's own references. (Distinct from `spaces.ts` — the selector
 * `space` atom's membership is deliberately declaring-file-based; identity
 * is landed.)
 *
 * Keys are conditional (plan D2): a spaceless entity's key is its bare
 * qualified path, byte-identical to the pre-v0.11 form, so single-space
 * workspaces — the overwhelming default — see zero churn. `::` cannot
 * appear in an identifier, so the two forms cannot collide.
 *
 * Uniqueness is `(space, ownerPath, name)` per entity family: two spaces may
 * each declare the same bare name (the §4.11 promise — "scoped resolution
 * keeps names from clashing"); a same-space duplicate stays the same hard
 * error as ever.
 */

import type { QualifiedName } from "./types.js";

/** `Space.Path::Qualified.Name` when a space is present; the bare qualified
 *  name otherwise. THE key shape for wire/scene/diff/app identity. */
export function spacedKey(
  space: QualifiedName | undefined,
  qualified: string,
): string {
  return space && space.length > 0 ? `${space.join(".")}::${qualified}` : qualified;
}
